<template>
  <div class="item-quantity">
    <p
      :class="[disableSubtract ? 'disable' : '', 'subtract']"
      @click="decreaseQty"
    />
    <p
      id="itemAmount"
      class="item-amount"
    >
      {{ quantity }}
    </p>
    <p
      :class="[disableAdd ? 'disable' : '', 'add']"
      @click="increaseQty"
    />
  </div>
</template>

<script>

export default {

  props: ['candelete', 'maxqty', 'quantity', 'updating'],
  computed: {
    disableAdd() {
      return this.quantity >= this.maxqty || this.updating == 'true'
    },

    disableSubtract() {
      if (this.candelete == 'true') {
        return this.updating == 'true'
      } else {
        return this.quantity <= 1 || this.updating == 'true'
      }
    }
  },

  methods: {
    decreaseQty() {
      if (this.disableSubtract) { return }

      if (this.quantity <= 1) {
        this.$emit('delete-item')
      } else {
        this.$emit('update-qty', this.quantity - 1)
        this.updateRoomQty('subtractRoom')
      }
    },

    increaseQty() {
      if (this.disableAdd) { return }
      this.$emit('update-qty', this.quantity + 1)
      this.updateRoomQty('addRoom')
    },

    updateRoomQty(action){
      let addRoom = document.getElementById('addRoom')
      if (action ==  'addRoom'){
        if (addRoom && addRoom.classList.value.includes('disable')){
          addRoom.classList.remove('disable')
        }
      }
      else if (action == 'subtractRoom' && document.getElementById('numberOfRooms').textContent == this.quantity){
        let subtractRoom = document.getElementById('subtractRoom')
        subtractRoom.click()
        setTimeout( function(){
          addRoom.classList.add('disable')
        }, 500)
      }

    }
  }
}
</script>
